<template>
    <footer id="footer" class="footer">
        <div class="footer-legal text-center">
          <div class="credits">
              <!-- All the links in the footer should remain intact. -->
              <!-- You can delete the links only if you purchased the pro version. -->
              <!-- Licensing information: https://bootstrapmade.com/license/ -->
              <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/herobiz-bootstrap-business-template/ -->
          </div>
          <div class="container d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center">
            <div class="copyright">
              <strong>
                <span>{{ $t('footerBar1') }}<br>
                {{ $t('footerBar2') }}<br>
              </span></strong>
              &copy; Copyright <strong><span>INCHEON CONTAINER TERMINAL Co.,Ltd.</span></strong> ALL RIGHTS RESERVED.<br>
              <a @click="$router.push({ path: '/Privacy'})" class="privacy">{{ $t('footerBar4') }}</a>
            </div><br>
            <div class="familySite">
              Family Site
              <select class="form-select" v-model="fms" ><option selected value="">{{ $t('footerBar3') }}</option><option value="http://www.globalpsa.com">Global PSA</option></select>
            </div>
          </div>
        </div>
    </footer>
</template>

<script src="@/assets/js/Common/FooterBar.js"></script>
<style scoped>
.container nav{
  padding: 0px;
  text-align: left;
}
.copyright{
  text-align: left;
}
.familySite{
  text-align: left;
}
.form-select{
  font-size: 14px;
  cursor: pointer;
  margin-top: 5px;
}
.privacy{
  cursor: pointer;color: white;font-weight: bold;
}
</style>
